import { LoginFormComponentData } from './../login-form/login-form.component';
import { AuthService } from "./../auth.service";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) { }

  loginFormVisible = false;

  ngOnInit() {
    this.authService.user$.subscribe(user => {
      if (user) {
        this.router.navigateByUrl(this.route.snapshot.queryParams['returnUrl'] || '/');
      }
    });
  }

  signInWithGoogle() {
    const that = this;
    this.authService.signInWithGoogle().catch((error) => { that.onError(error); });
  }

  signInWithFacebook() {
    const that = this;
    this.authService.signInWithFacebook().catch((error) => { that.onError(error); });
  }

  signInWithEmailAndPassword(loginData: LoginFormComponentData) {
    const that = this;
    if (loginData.isNew) {
      this.authService
        .createUserWithEmailAndPassword(loginData.email, loginData.password)
        .catch((error) => { that.onError(error); });
    } else {
      this.authService
        .signInWithEmailAndPassword(loginData.email, loginData.password)
        .catch((error) => { that.onError(error); });
    }
  }

  onError(error) {

    if (error.code === "auth/user-not-found") {
      // TODO
    } else {
      console.error(error);
      alert(error.message);
      this.authService.signOut().then(() => {
        console.log("signed out");
      });
    }


  }
}
